export enum EMaterskaSpol {
    ANO = 'Vede',
    ANO_SAME = 'Totozna',
    NE = 'Nevede',
    NELZE_UVEST = 'NelzeUvest'
}
